import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brwr-layout" }
const _hoisted_2 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brwr_header_view = _resolveComponent("brwr-header-view")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_brwr_footer_view = _resolveComponent("brwr-footer-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(
        _ctx.changeHeaderSideBar || _ctx.changeHeaderUserMenu
          ? 'header bg-white'
          : 'header'
      )
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_brwr_header_view)
      ])
    ], 2),
    _createElementVNode("section", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_2, [
      _createVNode(_component_brwr_footer_view)
    ])
  ]))
}